import React, { useEffect, useRef, useState } from 'react';
import { useLocale } from '../i18n/LocaleContext';
import { CheckIcon, PinIcon } from './Icons';

// Sits in the header rather than the filter drawer: which city you are browsing
// is context, not a filter you tweak. Harmless while the data is one city, and
// ready for the day it is not.
export default function CitySelector({ cities, value, onChange }) {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  if (cities.length === 0) {
    return null;
  }

  const select = (city) => {
    setOpen(false);
    onChange(city);
  };

  return (
    <div className="sort city-select" ref={ref}>
      <button
        type="button"
        className="city-select__button"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <PinIcon size={15} />
        {value || t('city.all')}
      </button>

      {open && (
        <ul className="sort__menu" role="listbox" aria-label={t('city.title')}>
          <li>
            <button
              type="button"
              role="option"
              aria-selected={!value}
              className={`sort__item${!value ? ' sort__item--active' : ''}`}
              onClick={() => select(undefined)}
            >
              {t('city.all')}
              {!value && <CheckIcon size={15} />}
            </button>
          </li>
          {cities.map((city) => (
            <li key={city.value}>
              <button
                type="button"
                role="option"
                aria-selected={value === city.value}
                className={`sort__item${value === city.value ? ' sort__item--active' : ''}`}
                onClick={() => select(city.value)}
              >
                {city.value}
                {value === city.value ? (
                  <CheckIcon size={15} />
                ) : (
                  <span className="chip__count">{city.count}</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
